import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  GetUserGroupByIdPayload,
  GetUserGroupByIdResponse,
  GetUserGroupsPayload,
  GetUserGroupsResponse,
  PostUserGroupPayload,
  PostUserGroupResponse,
  PutUserGroupPayload,
  PutUserGroupResponse
} from "@/types/groups";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getUserGroupsApi = async (params?: GetUserGroupsPayload) => {
  try {
    const { data }: { data: GetUserGroupsResponse } = await axiosInstance.get(
      "/v1/user-groups",
      { params }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const deleteUserGroupApi = async ({ id }: { id: string }) => {
  try {
    const { data } = await axiosInstance.delete(`/v1/user-groups/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message.message, status);
    throw newError;
  }
};

export const getUserGroupByIdApi = async ({ id }: GetUserGroupByIdPayload) => {
  try {
    const { data }: { data: GetUserGroupByIdResponse } =
      await axiosInstance.get(`/v1/user-groups/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const putUserGroup = async ({ id, ...payload }: PutUserGroupPayload) => {
  try {
    const { data }: { data: PutUserGroupResponse } = await axiosInstance.put(
      `/v1/user-groups/${id}`,
      { ...payload }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postUserGroup = async (payload: PostUserGroupPayload) => {
  try {
    const { data }: { data: PostUserGroupResponse } = await axiosInstance.post(
      "/v1/user-groups",
      payload
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
